import { SVGProps, Ref, forwardRef } from 'react';

export const ArchiveboxArrowOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.414 5.133c.305.055.66.067 1.044.067h10.805v5.519l-.002.098c-.023 1.65-.338 2.32-.68 2.646-.356.34-1.088.637-2.806.637H9v1.4h.775c3.59 0 4.836-1.172 4.886-4.663h.002V5.118c.288-.06.584-.174.826-.406.264-.252.382-.566.44-.864.058-.291.071-.63.071-.998 0-.367-.013-.707-.07-.998-.059-.298-.176-.612-.44-.864-.265-.252-.593-.365-.904-.421A6 6 0 0 0 13.542.5H2.458c-.384 0-.74.012-1.044.067-.311.056-.64.169-.903.421-.264.252-.382.566-.44.864-.058.291-.071.63-.071.998 0 .367.013.707.07.998.059.298.177.612.44.864.265.252.593.365.904.421M2.458 1.9c-.373 0-.622.014-.796.045l-.012.002c-.147.026-.178.032-.206.176-.03.148-.044.372-.044.727s.014.579.044.727c.028.144.059.15.206.176l.012.002c.174.031.423.045.796.045h11.084c.373 0 .622-.014.796-.045l.012-.002c.147-.026.178-.032.206-.176.03-.148.044-.372.044-.727s-.014-.579-.044-.727c-.028-.144-.059-.15-.206-.176l-.012-.002c-.174-.031-.423-.045-.796-.045z"
                        fill="currentColor"
                    />
                    <path
                        d="m4.179 6.412-2.99 2.99 2.99 2.989.99-.99-1.3-1.3h1.063c.984 0 1.766.917 1.766 2S5.916 14.1 4.932 14.1H1.999v1.4h2.933c1.948 0 3.166-1.75 3.166-3.4S6.88 8.702 4.932 8.702H3.869l1.3-1.3z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
ArchiveboxArrowOutlinedSize16Glyph.displayName = 'ArchiveboxArrowOutlinedSize16Glyph';
